import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireStatusDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    note: {
        alignItems: "flex-start"
    },
    container: {
        alignItems: "center",
        flexDirection: "row",
        minWidth: 0
    },
    time: {
        marginStart: "auto",
        fontVariant: [
            "tabular-nums"
        ]
    },
    icon: {
        flexShrink: 0
    },
    text: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: QuestionnaireStatusDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
